import React from 'react'

import { ButtonV2 } from '@vividseats/vivid-ui-kit'

interface Props {
    id?: string
    label?: string
    onClick: () => void
}

const DismissButton: React.FC<Props> = ({ id = 'modal', label = 'DISMISS', onClick }) => {
    return (
        <ButtonV2 importance="link" muted onClick={onClick} data-testid={`dismiss-${id}-button`}>
            {label}
        </ButtonV2>
    )
}

export default DismissButton
